import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";

export const BlackFriday = () => (
  <section
    id="black-friday"
    data-testid="black-friday-section"
    className="scroll-mt-28 bg-white text-black"
  >
    <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-500">
          Limited time only
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase tracking-tight sm:text-6xl lg:text-7xl">
          Black Friday <span className="text-zinc-400">sale.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-10 md:grid-cols-2">
        <Reveal delay={0.1}>
          <div data-testid="bf-offer-before" className="border-t-2 border-black pt-6">
            <p className="font-display text-5xl font-bold tracking-tight sm:text-6xl">25% OFF</p>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-zinc-600">
              On every service, right up until Black Friday. Book early and lock it in.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div data-testid="bf-offer-day" className="border-t-2 border-black pt-6">
            <p className="font-display text-5xl font-bold tracking-tight sm:text-6xl">50% OFF</p>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-zinc-600">
              Black Friday only. One day. Every service on the menu, half price.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.25}>
        <div className="mt-16 flex flex-col items-start gap-8 sm:flex-row sm:items-center">
          <div
            data-testid="bf-code"
            className="border-2 border-dashed border-black px-10 py-5 text-center"
          >
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
              Your code
            </p>
            <p className="mt-1 font-display text-3xl font-bold tracking-[0.15em] sm:text-4xl">
              BFDAH
            </p>
          </div>
          <a
            href="#contact"
            data-testid="bf-cta-button"
            className="inline-flex items-center gap-2 rounded-full bg-black px-7 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-zinc-800"
          >
            Mention code in your enquiry <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
        <p className="mt-8 max-w-xl text-xs leading-relaxed text-zinc-500">
          Mention code BFDAH when you send your enquiry to claim the discount. All sales are final
          — see our terms for the full refund policy.
        </p>
      </Reveal>
    </div>
  </section>
);
